import { render, staticRenderFns } from "./Peligros.vue?vue&type=template&id=0a545cc5&"
import script from "./Peligros.vue?vue&type=script&lang=js&"
export * from "./Peligros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports